import Ably from "ably"
import { ALTAR_BACKEND_URL } from "@/service/request"

/**
 * Create an Ably Realtime client authenticated via Clerk.
 *
 * Uses the authCallback approach: when Ably needs a token,
 * it calls our backend's /realtime/token endpoint which
 * creates a signed token request.
 *
 * @param getToken - Clerk's getToken function for JWT auth
 */
export function createAblyClient(
  getToken: () => Promise<string | null>
): Ably.Realtime {
  return new Ably.Realtime({
    authCallback: async (_tokenParams, callback) => {
      try {
        const token = await getToken()
        if (!token) {
          callback(new Error("Not authenticated"), null)
          return
        }

        const response = await fetch(`${ALTAR_BACKEND_URL}/realtime/token`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          credentials: "include",
        })

        if (!response.ok) {
          callback(
            new Error(`Token request failed: ${response.status}`),
            null
          )
          return
        }

        const tokenRequest = await response.json()
        callback(null, tokenRequest)
      } catch (err) {
        callback(err as Error, null)
      }
    },
    autoConnect: true,
  })
}
